module.exports = __webpack_public_path__ + "static/img/13.7e785ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/13.png
// module id = F1uP
// module chunks = 0